import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import "./Home.css";
import background from "../assets/background.png";

import frame20 from "../assets/20inchframe.jpg";
import speedybee from "../assets/speedybee5.jpg";
import mario from "../assets/mariodc5.jpg";
import volador from "../assets/VoladorVD.jpg";
import arduino from "../assets/Arduino.png";
import headphones from "../assets/headphones.jpg";
import smartwatches from "../assets/smartwatches.jpg";

function Home() {
  const products = [
    { id: 1, name: "20 Inch Frame", image: frame20, price: "₹1899" },
    { id: 2, name: "SpeedyBee 5", image: speedybee, price: "₹3449" },
    { id: 3, name: "Mario DC 5", image: mario, price: "₹3999" },
    { id: 4, name: "Volador VD5 Deadcat FPV Frame", image: volador, price: "₹5699" },
    { id: 5, name: "Arduino Board", image: arduino, price: "₹1000" },
    { id: 6, name: "Wireless Headphones", image: headphones, price: "₹1999" },
    { id: 7, name: "Smartwatches", image: smartwatches, price: "₹899" },
  ];

  const sliderRef = useRef(null);
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);
  const [startIndex, setStartIndex] = useState(0);

  // ✅ Auto-scroll only when enabled
  useEffect(() => {
    if (!autoScrollEnabled) return;
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 1) % products.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [autoScrollEnabled, products.length]);

  // ✅ Pause auto-scroll when user interacts manually
  const handleUserScroll = () => {
    setAutoScrollEnabled(false);
    clearTimeout(window.scrollTimeout);
    window.scrollTimeout = setTimeout(() => setAutoScrollEnabled(true), 5000); // resume after 5s idle
  };

  return (
    <div className="home" style={{ backgroundImage: `url(${background})` }}>
      <Navbar />

      <section className="hero box">
        <h1>Welcome to Flyza</h1>
        <p>
          Your trusted marketplace for <strong>new</strong> and
          <strong> pre‑owned products</strong> — drones, electronics, robotics,
          and more, tailored to your needs.
        </p>
        <button className="shop-btn">Start Shopping</button>
      </section>

      {/* ✅ Product showcase with smooth auto + manual scroll */}
      <section className="product-showcase box">
        <h2>Featured Products</h2>
        <div
          className="product-slider"
          ref={sliderRef}
          onScroll={handleUserScroll}
        >
          <div
            className="product-track"
            style={{
              transform: autoScrollEnabled
                ? `translateX(-${startIndex * 25}%)`
                : "none", // disable transform during manual scroll
              transition: autoScrollEnabled
                ? "transform 1.2s cubic-bezier(0.25, 0.8, 0.25, 1)"
                : "none",
            }}
          >
            {products.map((product) => (
              <div key={product.id} className="product-card">
                <img src={product.image} alt={product.name} />
                <h3>{product.name}</h3>
                <p>{product.price}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="features box">
        <h2>Why Shop With Us?</h2>
        <ul>
          <li>Wide range of categories</li>
          <li>Affordable options for every budget</li>
          <li>Eco‑friendly choices through re‑use</li>
          <li>Customer‑centric shopping experience</li>
        </ul>
      </section>

      <section className="quick-links box">
        <h2>Explore Categories</h2>
        <div className="links">
          <a href="/categories/drones">🚁 Drones</a>
          <a href="/categories/electronics">💻 Electronics</a>
          <a href="/categories/robotics">🤖 Robotics</a>
          <a href="/categories/essentials">📦 Essentials</a>
        </div>
      </section>
    </div>
  );
}

export default Home;
